// extracted by mini-css-extract-plugin
module.exports = {"icon":"LocalizationChangeButton_icon__8T_2K","languageOption":"LocalizationChangeButton_languageOption__1xFjK"};